module.exports = __webpack_public_path__ + "static/media/seniorDesign.af4896f3.jpg";